export const RESULT = "RESULT"
export const DETAIL_RESULT = "DETAIL_RESULT"